<template>
  <div class="ma-2 ml-3 site_content">
    <div class="flex s-bt mb-flex">
      <comboFarm
        @fromFarm="farmInfo"
      />

      <div class="weather_info mt-1">
        <div class="current-container">
            <div class="current-date">
              <div>오늘</div>
            </div>


            <div class="flex weather-info">
              <img class="weather-icon" :src="require('@/assets/monitoring/Weather/' + current.weather_icon + '.svg')" />
              <div class="weather-text">{{ current.weather_content }}</div>
            </div>

            <div class="degree-content">
              <div class="cur_info">{{ current.temp }} 
                <span class="info_unit">°C</span>
              </div>
              <div class="highlow_temp">
                <span class="blue-text">{{ current.lowest_temp }} </span>
                <span class="info_unit blue-text">°C</span>
                <span class="ml-1 mr-1">/</span>
                <span class="red-text">{{ current.highest_temp }}</span>
                <span class="info_unit red-text">°C</span>
              </div>
            </div>

            <div class="feel-content">
              <div v-if="deodorizerDevice_weather[0].sensor.pressure == null">기상</div>
              <div v-else >센서</div>
            </div>

            <div class="flex vertical-center" v-if="deodorizerDevice_weather[0].sensor.pressure == null">
              <div class="wind-section">
                <div class="wind-content flex">
                  <img :src="icon_windy" class="mr-1 mb-icon" />
                  <div class="cur_info mr-1"> {{ current.wind.speed }} </div>
                  <span class="unit">m/s</span>
                  <span class="ml-2 mr-2 bold-text"> | </span>
                  <div> {{ getdirection(current.wind.deg) }} </div>
                </div>
              </div>

              <div class="press-section mt-1">
                <div class="press-content flex col">

                  <div class="flex">
                    <div class="wind-icon ml-1">
                      <img :src="icon_press" class="mb-icon"/>
                    </div>
                    <span class="bold-text wind-text ml-1">{{ current.wind.ps }}</span>
                    <span class="unit">hPa</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 기상센서 -->
            <div class="flex vertical-center" v-else>
              <div class="wind-section">
                <div class="wind-content flex">
                  <img :src="icon_windy" class="mr-1 mb-icon" />
                  <div class="cur_info mr-1"> {{ deodorizerDevice_weather[0].sensor.wind.speed }} </div>
                  <span class="unit">m/s</span>
                  <span class="ml-2 mr-2 bold-text"> | </span>
                  <div> {{ getdirection(deodorizerDevice_weather[0].sensor.wind.deg) }} </div>
                </div>
              </div>

            <div class="press-section mt-1">
              <div class="press-content flex col">

                <div class="flex">
                  <div class="wind-icon ml-1">
                    <img :src="icon_press" class="mb-icon"/>
                  </div>
                  <span class="bold-text wind-text ml-1">{{ deodorizerDevice_weather[0].sensor.pressure }}</span>
                  <span class="unit">hPa</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <v-tabs v-model="tab" class="deodorizer-tab">
        <v-tab v-for="plc in items" :key="plc.plc_name" class="custom-tab">
          <pre><span v-if="plc.watt" class="watt pl-3 pr-3">{{ plc.watt }}<span style="font-size:12px;"> kW</span><span style="font-size:11px;"> / 1일</span></span>
  {{ plc.plc_name }}
  </pre>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="mt-1 tab-content">
        <v-tab-item  v-for="plc_id in items" :key="plc_id.mac">
          <div class="monitor-container">
          <div class="tree__monitor">
            <div class="tree_warning_monitor" v-if="plc_id.warning != null"> 
              <div class="warning_plc blink"> 
                <img class="warning_plc_icon" :src="warning_plc" />
                <div class="warning_plc_info">{{ plc_id.warning }}</div>
              </div>
          </div>

          <div v-if="$getters.userInfo.grade < 'UT06'" class="entry__setting">
            <div class="auto_set">
              <div class="entry_title">전체</div>
              <img class="entrymode_icon allrun" :src="automode" @click=Allautocontrol(plc_id) />
              <img class="entrymode_icon allmanual" :src="manualmode" @click=Allpoweron(plc_id)  />
              <img class="entrymode_icon allstop" :src="allstop" @click=Allpoweroff(plc_id) />
            </div>
          </div>

          <div class="tree_container">
            <div id="tree" >
              <div class="entry_first " v-for="(control, c) in plc_id.children" :key="c">
                <div class="control__info compressor_error blink" 
                  v-if="control.type.code ==='OD01' && ( control.status.err_comp_max_pressure == 'on' || control.status.err_comp_signal == 'on' ) ">
                    <img class="warning_icon" :src="warning_img" />
                  <div>
                    <div class="warning__info pb-1" v-if="control.status.err_comp_max_pressure == 'on'"> 컴프레서 압력 이상</div>
                    <div class="warning__info" v-if="control.status.err_comp_signal == 'on'"> 컴프레서 신호 이상</div>
                  </div>
                </div>

                <div class="control__info">
                  <!-- 콤프레서 -->
                  <div class="deodorizer__icon" v-if="control.type.code === 'OD01'">
                    <img class="compressor_icon" :src="compressor" />
                  </div>

                  <!-- 탱크 -->
                  <div v-if="control.type.code === 'OD03'">
                    <div class="deodorizer__icon" v-for="level in plc_id.children[c].status" :key="level">
                      <div v-if="level === 'level_bottom'">  
                        <img class="tank_icon" :src="level_bottom" /><span class="level_info">최소 이하</span>
                      </div>  
                      <div v-else-if="level === 'level_low'">  
                        <img class="tank_icon" :src="level_low"/><span class="level_info">낮음</span>
                      </div>  
                      <div v-else-if="level === 'level_middle'">  
                        <img class="tank_icon" :src="level_middle"/><span class="level_info">중간</span>
                      </div>  
                      <div v-else-if="level === 'level_top'">  
                        <img class="tank_icon" :src="level_top"/><span class="level_info">높음</span>
                      </div>  
                      <div v-else>  
                        <img class="error_icon" :src="level_error"/>
                      </div>
                    </div>
                  </div>

                  <div> {{ control.device_name }}</div>
                </div>

                <div class="branch" v-if="control.children.length > 0">
                  <div class="device__entry" v-for="(device, d) in control.children" :key="d">
                    <div class="device_pump_info compressor_error blink" v-if="device.type.code ==='OD04' && device.status.err_pump == 'on' ">
                      <img class="warning_icon" :src="warning_img" style="height:55px;" />
                      <div>
                        <div class="warning_device_info" v-if="device.status.err_pump == 'on'"> 펌프 이상 </div>
                      </div>
                    </div>

                    <div class="device_pump_info"  v-if="device.type.code === 'OD04'"> 
                      <div class="deodorizer__icon">
                        <img class="pump_icon" :src="pump" >

                        <div class="pump__info"> 
                          <div class="ml-1 mb-2" style="font-size:17px; font-weight:900">
                            <v-icon class="mr-1" color="#3a4f3f">mdi-radio-tower</v-icon> 동작 정보</div>
                          <div class="pump__detail mb-2">
                            <div>용량 (최소-최대) : 
                              <span> {{ device.minoutput }} L/분 </span>  
                              <span> - </span> 
                              <span> {{ device.maxnoutput }} L/분 </span>
                            </div>

                            <div class="mt-2" style="background-color:white; border-radius:10px; padding:5px;">
                              <v-icon color="#3a4f3f"> mdi-refresh mdi-spin </v-icon> 현재 가동 용량 : 
                              <span class="ml-1" style="font-size:17px;">{{ device.status.runningvolume }}</span> 
                              <span> L/분</span>
                            </div>
                          </div>

                          <div class="pump__detail">
                            <div>
                              가동시간 : 
                              <span>{{ device.minruntime }} 분 </span>
                              <span> - </span>
                              <span>{{ device.maxruntime }} 분 </span>
                            </div>
                            <div> 최소 중단 시간 : {{ device.minstoptime }} 분</div>
                            <div class="mt-2" style="background-color:white; border-radius:10px; padding:5px; ">
                              <v-icon color="#3a4f3f">mdi-clock mdi-spin</v-icon>현재 연속 가동 시간 : 
                              <span class="ml-1 mr-1" style="font-size:0.9rem; width:80px;"> {{ device.status.now == "run" ? device.status.runningtime : 0 }}</span>
                              <span>분</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="device__name">{{  device.device_name }}</div>
                    </div>

                    <div class="device_hocl_info"  v-if="device.type.code === 'OD02'"> 
                      <div class="deodorizer__icon">
                        <img class="hocl_icon" :src="hocl" />
                      </div>
                      <div class="hocl__name">{{  device.device_name }}</div>
                    </div>

                    <div class="deodorizer_branch" v-if="device.children.length > 0">
                      <div class="entry" v-for="(deodorizer, z) in device.children" :key="z">
                        <div class="deodorizer__error compressor_error blink" style="display:flex" 
                          v-if="(deodorizer.type ==='OT04' || deodorizer.type === 'OT03') && ( deodorizer.err_scrubber_fan == 'on' || deodorizer.err_scrubber_pump == 'on' ) ">
                          <img class="deodorizer_warning_icon mr-1" :src="warning_img" />
                          <div style="display:flex;">
                            <div class="deodorizer_warning__info" v-if="deodorizer.err_scrubber_fan == 'on'"> 스크라버 팬 이상</div>
                            <div class="deodorizer_warning__info ml-1 mr-1" v-if="deodorizer.err_scrubber_fan == 'on' && deodorizer.err_scrubber_pump  == 'on'"> /</div>
                            <div class="deodorizer_warning__info" v-if="deodorizer.err_scrubber_pump  == 'on'"> 스크라버 펌프 이상</div>
                        </div>
                      </div>
                      
                      <div class="deodorizer__name" :class="{device_run: deodorizer.running === 'on', gray: device.status.err_pump == 'on'}">
                        <div class="deodorizer__info"> 
                          <img class="wash_icon" :src="wash" v-if=" deodorizer.cleaning === 'on'"/>
                          <div style="display:flex; font-size:17px; letter-spacing: -1px;">
                            <img class="line_icon run" :src="deodorizer_line" v-if="deodorizer.type === 'OT01' && deodorizer.running === 'on'"/>
                            <img class="line_icon stop" :src="deodorizer_line" v-if="deodorizer.type === 'OT01' && deodorizer.running === 'off'"/>
                            <img class="tower_icon run" :src="deodorizer_tower" v-if="(deodorizer.type === 'OT03' || deodorizer.type === 'OT04') && deodorizer.running === 'on' "/>
                            <img class="tower_icon stop" :src="deodorizer_tower" v-if="(deodorizer.type === 'OT03' || deodorizer.type === 'OT04')  && deodorizer.running === 'off' "/>
                            
                            {{ deodorizer.device_name }}({{ deodorizer.map_no }}) 
                          </div>

                          <!-- 모드표시 영역 -->
                          <div style="display:flex; align-items: center;">
                            <div class="mode_icon auto" v-if="deodorizer.mode === 'auto'"> 
                              <v-icon color="white" size="12">mdi-autorenew mdi-spin</v-icon>
                              제어
                            </div>
                            <img :src="switch_on" class="power_icon" @click=poweroff(deodorizer) v-else-if="deodorizer.mode === 'manual' && deodorizer.running === 'on'"/> 
                            <img :src="switch_off" class="power_icon" @click=poweron(deodorizer) v-else-if="deodorizer.mode === 'manual' && deodorizer.running === 'off'"/>
                            <div class="mode_icon local" v-else-if="deodorizer.mode === 'local'"> 현장 </div>
                            <div v-else class="warning_icon_small mr-2">
                              <img :src="warning_img" class="warning_icon_small mr-2">
                              <div class="warning__notice"> 
                                관리자에게 문의하세요. <br/>
                                [ 원스프링 CS ] 041-406-7775
                              </div>
                            </div>
                          
                            <!-- 자동.수동 전환 표시영역 -->
                            <div class="auto__control ml-1" v-if="deodorizer.mode !== 'local'">
                              <div class="mr-1" style="font-size:14px;">자동</div>
                              <img :src="play" class="auto_icon pt-1" @click=autocontrol(deodorizer) 
                                :class="{run_mode: deodorizer.mode === 'manual', disabledbutton: !deodorizer.auto_enable}" v-if="deodorizer.mode === 'manual'" />
                              <img :src="stop" class="auto_icon pt-1" @click="manualcontrol(deodorizer)" 
                                :class="{stop_mode:deodorizer.mode === 'auto',disabledbutton: !deodorizer.auto_enable}" v-else-if="deodorizer.mode === 'auto' "/>
                              <div class="manual pt-1"  v-else-if="deodorizer.mode === 'local'" style="display:none;"> </div>
                              <div class="manual pt-1" :class="{disabledbutton: deodorizer.auto_enable}" v-else @click="manualcontrol(deodorizer)"> </div>
                              <img :src="setting" class="auto_icon pt-1" @click="controlset(deodorizer.id)" />
                              </div>
                              <div class="local_auto_control ml-1" v-if="deodorizer.mode === 'local'" @click="controlset(deodorizer.id)"> 자동설정</div>
                            </div>       
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
             </div>
            </div>
          </div>

          <div class="treeview" outlined>
            <div class="mt-3">
              <div v-if="plc_id.histories.length > 0" style="display:flex;">
                <div class="history__title pt-2" @click="historydialog()">
                  <v-icon color=white size="25">mdi-history</v-icon>
                  이력 정보
                </div>

                <v-dialog
                v-model="dialog"
                max-width="500">

                  <v-card class="pa-4" style="border-radius:10px; background-color: #F2F2F2;">
                    <div class="history__title">
                      <v-icon color=white size="25">mdi-history</v-icon>
                      상세 이력
                    </div>

                      <div class="histories__contents" v-for="(histories,h) in plc_id.histories" :key="h"> 
                        <div style="padding:5px; letter-spacing: -1px; line-height:20px;">
                          <div style="font-weight:500;" :class="{result_blue: histories.result === true, result_red: histories.result == false }">
                            {{ histories.msg }}
                          </div>
                          <div style="font-size:15px;">
                            <span class="mr-1"> {{ histories.setdate }} </span> 
                            <span class="mr-1" style="font-weight: 900; "> | </span>
                            <span> {{ histories.setuser }} </span>
                            
                          </div>
                        </div>
                      </div>
                      
                  <v-card-actions class="justify-center mt-2">
                    <v-btn class="priority_btn" rounded outlined @click="dialog=false">
                      확인
                    </v-btn>
                  </v-card-actions>
                  </v-card>
                </v-dialog>

                <div class="histories__contents ml-2 pl-5 pr-5">
                  <span> {{ plc_id.histories[0].setdate }} </span>
                  <span class="mr-1" style="font-weight:900"> | </span>
                  <span class="mr-1" :class="{result_blue: plc_id.histories[0].result === true, result_red: plc_id.histories[0].result == false }" > {{ plc_id.histories[0].msg }}  </span>
                  
                </div>
              </div>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    
  </div>
</template>

<script>
import Apis from '@/api/apis';
import VueCookies from "vue-cookies";

import Common from "@/utils/custom/common.js";

import comboFarm from "@/components/combo/farm.vue";

var setTime = 0;

export default{
  name: "DeodorizerMachineRoom",
  components:{
    comboFarm,
  },
  data() {
    return {
      farmData: { company: {}, farm: {} },
      current: { wind:{speed:''}},
      deodorizerDevice_weather:[{sensor:{}}],

      icon_windy: require("@/assets/monitoring/icon/windy_dash.svg"),
      icon_humi: require("@/assets/monitoring/icon/humi_dash.svg"),
      icon_press: require("@/assets/monitoring/icon/press_dash.svg"),

      level_bottom: require("@/assets/deodorizer/water_tank_bottom.svg"),
      level_low: require("@/assets/deodorizer/water_tank_low.svg"),
      level_middle: require("@/assets/deodorizer/water_tank_middle.svg"),
      level_top: require("@/assets/deodorizer/water_tank_top.svg"),
      level_error : require("@/assets/deodorizer/water_level_error.svg"),

      compressor : require("@/assets/deodorizer/air_compressor.svg"),
      pump : require("@/assets/deodorizer/pump.svg"),
      hocl : require("@/assets/deodorizer/hocl.svg"),


      deodorizer_tower: require("@/assets/deodorizer/deodorizer_tower.svg"),
      deodorizer_line: require("@/assets/deodorizer/deodorizer_line.svg"),

      wash : require("@/assets/deodorizer/deodorizer_wash.svg"),
      warning_img : require("@/assets/deodorizer/warning.svg"),
      warning_plc : require("@/assets/deodorizer/wraning_plc.svg"),
      
      watt: require("@/assets/deodorizer/watt.svg"),
      error: require("@/assets/deodorizer/error.svg"),

      switch_on: require("@/assets/deodorizer/switch_on.svg"),
      switch_off: require("@/assets/deodorizer/switch_off.svg"),
  
      power: require("@/assets/deodorizer/power.svg"),
      
      play: require("@/assets/deodorizer/play.svg"),
      stop: require("@/assets/deodorizer/stop.svg"),
      setting: require("@/assets/deodorizer/setting.svg"),

      automode: require("@/assets/deodorizer/AutoMode.svg"),
      manualmode: require("@/assets/deodorizer/ManualMode.svg"),
      allstop: require("@/assets/deodorizer/AllStop.svg"),

      dialog:false,
      
      items:[],
      tab:null,

      loading: false,
      
    }
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 
    let cookie_info = VueCookies.get("DeodorizerDviceMonitoring"); // 이전 조회정보를 참조
    if (!this.isNull(this.$route.params)) {
      this.tab = this.$route.params.tab;
    } else if (cookie_info) {
        this.tab = cookie_info.tab || 0;
    } else {  // 이전 조회정보가 없을 경우 첫번째 농장/사업장 디폴트로 참조
        this.tab = 0;
    }
  },
  methods:{
    farmInfo(data){
      // console.log(data)
      this.farmData = data;
      this.refresh();
      this.monitor();
    },
    refreshDeodorizer() {
      clearTimeout(setTime);
      this.monitor();
    },
    refresh(){
      this.$store.commit("resMessage","");
      // this.loading = true;

      Apis.weatherForecast({
        farm_cd : this.farmData.farm.code,
      },(res) => {  
        if (res.result) {
        this.current = res.data.current;

        this.$store.commit("resMessage",res.message);
      } else {
        alert(res.message);
      }
      this.loading = false;
      }).catch( (err) => {  // API 오류 처리
        console.log("weatherForecast API 호출 오류",err)
        this.loading = false;
      })

      Apis.weatherForDeodorizer({
        farm_cd:  this.farmData.farm.code,
      } ,(res) => {
        // NOTE: 해당 농장/사업장정보에 등록된 위치정보 기반 날씨 정보
        // console.log("weather=",res.data)

        this.deodorizerDevice_weather = res.data;

        // console.log("deg", res.data[0].wind)
      });
    },
    monitor(){
      Apis.treeDeodorizerDviceMonitoring({
        farm_cd: this.farmData.farm.code,
      } ,(res) => {  // 정상처리
        // console.log(res)
        if (res.resultCode != "N000" ) {
          this.$store.commit("resMessage",res.message);
          setTimeout( () =>  this.$store.commit("resMessage",""), 7 * 1000);
        }
        else if (this.$route.path == "/deodorizerMonitoring") {setTime = setTimeout( () =>  this.monitor(), 7 * 1000);}
        this.items = res.data;
        this.loading = false;
        // console.log("setTime",setTime);

      }).catch( (err) => {  // 개별 API 오류 처리 예제
        this.loading = false;
        console.log("treeDeodorizerDviceMonitoring 호출 오류",err);
        if (this.$route.path == "/deodorizerMonitoring") setTime = setTimeout( () =>  this.monitor(), 7 * 1000);
        // alert("treeDeodorizerDviceMonitoring 호출 오류" + err);
      });
    },
    getdirection(item){
      return Common.getDirectionOnly(item);
    },
    historydialog(){
      event.stopPropagation();    // 상위박스 클릭이벤트 중복방지
      this.$store.commit("resMessage","");
      // console.log(item);
      this.dialog = true;
    },

    async Allpoweron(plc){
      event.stopPropagation();
      // console.log(plc);
      if (!confirm("해당 기계실 전체 탈취라인을 수동 작동하시겠습니까?")) return;
      clearTimeout(setTime);
      this.loading = true;
      // let result = false;

      await Apis.deodorizerOnAllLines({
        plc: { mac: plc.mac, slave_id: plc.slave_id, device_name: plc.plc_name, id: plc.plc_id},
        under_control: false,   // 최소가동 한도 적용 여부?
        over_control: false,   // 최대가동 한도 적용 여부?

      } ,(res) => {  // 정상처리
        this.$store.commit("resMessage",res.message);
        // result = res.result;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("deodorizerOnAllLines 호출 오류",err);
        alert("deodorizerOnAllLines 호출 오류" + err);
      });
      // if (result)  this.refresh();
      this.refreshDeodorizer();
      setTimeout( () =>  this.$store.commit("resMessage",""), 15 * 1000);
    },

    async Allpoweroff(plc){
      event.stopPropagation();
      if (!confirm("해당 기계실 전체 탈취라인을 수동 중지하시겠습니까?"))  return;

      clearTimeout(setTime);
      this.loading = true;
      // let result = false;

      await Apis.deodorizerOffAllLines({
        plc: { mac: plc.mac, slave_id: plc.slave_id, device_name: plc.plc_name, id: plc.plc_id},
        under_control: false,   // 최소가동 한도 적용 여부?
        over_control: false,   // 최대가동 한도 적용 여부?

      } ,(res) => {  // 정상처리
        this.$store.commit("resMessage",res.message);
        // result = res.result;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("deodorizerOffAllLines 호출 오류",err);
        alert("deodorizerOffAllLines 호출 오류" + err);
      });
      // if (result)  this.refresh();
      this.refreshDeodorizer();
      setTimeout( () =>  this.$store.commit("resMessage",""), 15 * 1000);
    },

    async Allautocontrol(plc){
      event.stopPropagation();
      if (!confirm("해당 기계실 전체 탈취라인을 자동제어 시작 하시겠습니까?"))  return;

      clearTimeout(setTime);
      this.loading = true;
      // let result = false;

      await Apis.deodorizerAutoAllLines({
        plc: { mac: plc.mac, slave_id: plc.slave_id, device_name: plc.plc_name, id: plc.plc_id},
        under_control: false,   // 최소가동 한도 적용 여부?
        over_control: false,   // 최대가동 한도 적용 여부?

      } ,(res) => {  // 정상처리
        this.$store.commit("resMessage",res.message);
        // result = res.result;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("deodorizerAutoAllLines 호출 오류",err);
        alert("deodorizerOAutoAllLines 호출 오류" + err);
      });
      // if (result)  this.refresh();
      this.refreshDeodorizer();
      setTimeout( () =>  this.$store.commit("resMessage",""), 15 * 1000);
    },

    async poweron(deodorizer){
      event.stopPropagation();
      if (this.$getters.userInfo.grade > 'UT06') {alert("제어 권한이 없는 사용자 입니다");  return;}
      if (!confirm("해당 디바이스를 작동하시겠습니까?"))  return;
      clearTimeout(setTime);

      this.loading = true;
      // let result = false;
      await Apis.deodorizerOnLines({
        deodorizer: deodorizer,
        under_control: false,   // 최소가동 한도 적용 여부?
        over_control: false,   // 최대가동 한도 적용 여부?

      } ,(res) => {  // 정상처리
        this.$store.commit("resMessage",res.message);
        // result = res.result;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("deodorizerOnLines 호출 오류",err);
        alert("deodorizerOnLines 호출 오류" + err);
      });
      // if (result)  this.refresh();
      this.refreshDeodorizer();
      setTimeout( () =>  this.$store.commit("resMessage",""), 15 * 1000);
      // this.loading = false;
    },

    async poweroff(deodorizer){
      event.stopPropagation();
      if (this.$getters.userInfo.grade > 'UT06') {alert("제어 권한이 없는 사용자 입니다");  return;}
      if (!confirm("해당 디바이스를 정지하시겠습니까?"))  return;

      clearTimeout(setTime);
      this.loading = true;
      // let result = false;
      await Apis.deodorizerOffLines({
        deodorizer: deodorizer,
        under_control: false,   // 최소가동 한도 적용 여부?
        over_control: false,   // 최대가동 한도 적용 여부?

      } ,(res) => {  // 정상처리
        this.$store.commit("resMessage",res.message);
        // result = res.result;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("deodorizerOffLines 호출 오류",err);
        alert("deodorizerOffLines 호출 오류" + err);
      });
      // if (result)  this.refresh();
      this.refreshDeodorizer();
      setTimeout( () =>  this.$store.commit("resMessage",""), 15 * 1000);
    },

    async autocontrol(deodorizer){
      event.stopPropagation();
      if (this.$getters.userInfo.grade > 'UT06') {alert("제어 권한이 없는 사용자 입니다");  return;}
      if (!confirm("자동 제어를 시작하시겠습니까?"))  return;
      clearTimeout(setTime);
      this.loading = true;
      // let result = false;
      await Apis.deodorizerAutoLines({
        deodorizer: deodorizer,
        under_control: false,   // 최소가동 한도 적용 여부?
        over_control: false,   // 최대가동 한도 적용 여부?

      } ,(res) => {  // 정상처리
        this.$store.commit("resMessage",res.message);
        // result = res.result;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("deodorizerAutoLines 호출 오류",err);
        alert("deodorizerAutoLines 호출 오류" + err);
      });
      // if (result)  this.refresh();
      this.refreshDeodorizer();
      setTimeout( () =>  this.$store.commit("resMessage",""), 15 * 1000);
    },

    async manualcontrol(deodorizer){
      event.stopPropagation();

      if (this.$getters.userInfo.grade > 'UT06') {alert("제어 권한이 없는 사용자 입니다");  return;}
      if (!confirm("수동 제어로 전환하시겠습니까?"))  return;
      clearTimeout(setTime);
      this.loading = true;
      // let result = false;
      await Apis.deodorizerManualLines({
        deodorizer: deodorizer,
        under_control: false,   // 최소가동 한도 적용 여부?
        over_control: false,   // 최대가동 한도 적용 여부?

      } ,(res) => {  // 정상처리
        this.$store.commit("resMessage",res.message);
        // result = res.result;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("deodorizerManualLines 호출 오류",err);
        alert("deodorizerManualLines 호출 오류" + err);
      });
      // if (result)  this.refresh();
      this.refreshDeodorizer();
      setTimeout( () =>  this.$store.commit("resMessage",""), 15 * 1000);
    },

    controlset(id){
      let cookie_info = {tab: this.tab};
      VueCookies.set("DeodorizerDviceMonitoring" ,cookie_info,"30d");
      
      this.$router.push({
        name: "DeodorizerSetting",
        params: {
          id: id
        }
      });
    },
  }
}

</script>

<style scoped lang="scss">
@import '../../style/base.scss';
@import './style/deodorizer.scss';

.weather_info{
  width:50vw;
}
// 현재날씨
.current-container{
  border-radius: 30px;
  background: #FFFFFF;
  box-shadow: 0px 0.5px 4px rgba(0, 0, 0, 0.25);
  display: flex; 
  width: 100%; 
  max-width:600px;
  height: 55px;
  align-items: center;
  justify-content: space-evenly; /* 자식 요소들을 균등하게 배치 */
  margin: 0 auto;
  line-height: 15px;
}
.current-date{
  text-align: center;
  font-size:0.9rem;
  font-weight:$semibold-weight;
  min-width:10%;
}
.weather-icon{
  width: 2.5rem; /* 이미지 크기를 줄임 */
  height: 2.5rem; /* 이미지 크기를 명시적으로 지정 */
}

.weather-info{
  min-width:18%;
  justify-content: center;
  align-items: center;
}
.degree-content{
  min-width:15%;
  text-align: center;
}
.feel-content{
  min-width:10%;
  text-align: center;
}
.feel-content div{
  margin-left:10px;
  background-color: $main-color;
  border-radius: 15px;
  padding:7px;
  font-size:14px;
  font-weight:500;
  color:white;
}
.degree-content{
  font-size:1.1rem;
  font-weight:$bold-weight;
}
.highlow_temp{
  font-size:0.8rem;
  letter-spacing: -1px;
  font-weight:$semibold-weight;
}
.small-text{
  font-size:$small-font !important;
  margin-right:5px;
}
.bold-text{
  font-weight:$bold-weight;
  font-size:13px !important;
}
.info_unit{
  vertical-align:top;
  font-size:0.7rem;
}
.wind-section{
  min-width:20%;
  justify-content: center;
}
.press-section{
  min-width:18%;
}
.press-content{
  justify-content: left;
}
.wind-content{
  align-items: center;
}
.wind-icon{
  width:20px;
  height:20px;
}
.wind-text{
  width:35px;
  text-align: left;
}

.tab-content{
  width:100%;
  background-color: #F3F3F3;
  // border-radius: 5px
}
.custom-tab{
 width:10vw !important;
 font-weight:$bold-weight;
 letter-spacing: -0.75px;
 font-size:0.9rem;
}
// 모바일
@media only screen and (max-width: 768px) {
  .site_content{
    display:block !important;
  }
  .mb-flex{
    flex-direction: column !important;
  }
  .weather_info{
    width:85vw !important;
    min-width:360px !important;
    margin:0 auto !important;
    margin-top: 10px !important;
  }
  .weather_info{
    width:50px !important;
    margin:0 !important;
    margin-top:10px !important;
  }
  .custom-tab{  
    width:140px !important;
  }
  .highlow_temp{
    display: none;
  }
  .feel-content{
    display: none;
  }
  .current-date{
    display: none;
  }
  .weather-info{
    min-width:10%;
  }
  .wind-content .flex{
    flex-direction: row !important; 
  }
}
</style>